import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import {StepConnector} from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
const useStyles = makeStyles((theme) => ({

    stepper: {
      width: "100%"
    },
    root: {
        backgroundColor: theme.palette.inPatient.stepperRoot,
        padding: 5,
        borderRadius: '50%',
        height: 36,
        width: 36,
        fontSize: "12px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    active: {
        backgroundColor: theme.palette.inPatient.stepperActive,
        outline: "2px solid "+ theme.palette.inPatient.stepperActive,
        border: "4px solid " + theme.palette.inPatient.stepperRoot,//#313233"
        color: "white"
    },
    completed: {
       // backgroundColor: 'green',
    },


}));
function AgyleStepper({steps, activeStep, isStepFailed, handleStep}) {

    const classes = useStyles();


    const CustomStepIcon = (props) => {
        const classes = useStyles();
        const { active, completed } = props;


        return (
            <div className={clsx(classes.root, {
                    [classes.active]: active,
                    [classes.completed]: completed,
                })}
            >
                {completed? <DoneIcon/>: props.icon}
            </div>
        );
    }

    return <div>  <div className={classes.stepper}>
        <Stepper alternativeLabel activeStep={activeStep} connector={<StepConnector style={{top: 18}}/>}>
            {steps.map((label, index) => {
                const stepProps = {};
                const labelProps = {};

                stepProps.completed = false;

                if(isStepFailed) {
                    if(!isStepFailed(index)){
                        stepProps.completed = true;
                    }
                }

                let labelHtml = label;
                if(activeStep === index) labelHtml = <span style={{fontWeight: 700}}> {label} </span>;

                return (
                    <Step key={label} {...stepProps}  onClick={handleStep(index)}>
                        <StepLabel {...labelProps} StepIconComponent={CustomStepIcon} style={{cursor: "pointer"}}>
                            {labelHtml}
                        </StepLabel>
                    </Step>
                );
            })}
        </Stepper>
    </div> </div>
}

export default AgyleStepper;